import { render, staticRenderFns } from "./EstimatedInsuranceRequiredOutput.vue?vue&type=template&id=66af00c6&scoped=true"
import script from "./EstimatedInsuranceRequiredOutput.vue?vue&type=script&lang=js"
export * from "./EstimatedInsuranceRequiredOutput.vue?vue&type=script&lang=js"
import style0 from "./EstimatedInsuranceRequiredOutput.vue?vue&type=style&index=0&id=66af00c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66af00c6",
  null
  
)

export default component.exports